import axios from "axios";

/**
 * Retrieves all sections and trainings for a season in a single optimized call
 * This endpoint performs only 3 SQL queries total (vs N+1 with individual calls):
 * 1. Get all sections for the season
 * 2. Get all trainings for those sections
 * 3. Get all values for those trainings
 *
 * @param season_id - The season ID to fetch data for
 * @returns Promise with array of sections, each containing nested trainings with values
 *
 * Response structure:
 * [
 *   {
 *     id: number,
 *     name: string,
 *     order: number,
 *     collapsed: number,
 *     trainings: [
 *       {
 *         id: number,
 *         codigo: string,
 *         tipo: string,
 *         carga: number,
 *         descripcion: string,
 *         comentarios: string,
 *         values: [{ value_key: string, value: string }]
 *       }
 *     ]
 *   }
 * ]
 */
export function getTrainingsBySeason(season_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/training-by-season/' + season_id;
    return axios.get(endpointUrl, { headers: headers });
}

export function getTrainingBySection(section_id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/training/section/' + section_id + '/trainings';
    return axios.get(endpointUrl, { headers: headers } );
}

export function getTrainingSingle(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/training/' + id;
    return axios.get(endpointUrl, { headers: headers } );
}

export function createTraining(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/training';
    return axios.post(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function updateTraining(body_obj: any) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/training';
    return axios.patch(endpointUrl, JSON.stringify(body_obj), { headers: headers });
}

export function deleteTraining(id: number) {
    const token = localStorage.getItem('token');
    const headers = {
        'Authorization': 'Bearer ' + token,
        'Content-Type': 'application/json'
    }
    let endpointUrl = process.env.REACT_APP_API_BASE_URL + '/wp-json/padeltech/ws/v1/training/' + id;
    return axios.delete(endpointUrl, { headers: headers });
}
